import React from 'react';
import CellContent from '../../common/CellContent/CellContent';
import TypeIcon from '../HouseRegistrationTypeManager/components/TypeIcon/TypeIcon';

const AccessTypeContent = ({ accessType, record, registrationTypeHouse }) => {
  return (
    <CellContent
      topRowContent={
        !!accessType ? (
          <TypeIcon type={registrationTypeHouse || { id: 0, name: '' }} />
        ) : null
      }
      isHighlighted={false}
    />
  );
};

export default AccessTypeContent;
